const IDENTITY_CONFIG = {
  authority: process.env.REACT_APP_AUTH_URL,
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URL,
  login: 'http://localhost:5010/login',
  automaticSilentRenew: true,
  loadUserInfo: true,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOFF_REDIRECT_URL,
  scope: 'openid profile',
}

export default IDENTITY_CONFIG
